<template>
  <div>
    <v-layout align-center wrap class="mb-2" :style="{ margin: '-8px' }">
      <v-flex class="headline primary--text pa-2">Top 5 of Question</v-flex>
      <v-flex class="pa-2" shrink>
        <v-btn color="primary" @click="handleExportButtonClick">
          <v-icon>logout</v-icon>
          Export
        </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      id="topQuestion"
      :headers="headers"
      :items="items"
      hide-actions
      :pagination="{ rowsPerPage: -1 }"
      :loading="loading"
    >
      <template #items="{ item }">
        <td>{{ item.topic }}</td>
        <td class="text-xs-right">
          {{ item.recrived }} ({{ Math.round(item.recrived_percent) }}%)
        </td>
        <td class="text-xs-right">
          {{ item.resolved }} ({{ Math.round(item.resolved_percent) }}%)
        </td>
        <td>
          <v-btn flat icon color="primary" @click="() => view(item)">
            <v-icon>search</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ttbApi from '@/api/ttb'
import { mapGetters } from 'vuex'
export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      headers: [
        { text: 'Topic', value: 'topic', sortable: false },
        { text: 'Received', value: 'recrived', sortable: false, align: 'right' },
        { text: 'Resolved', value: 'resolved', sortable: false, align: 'right' },
        { text: 'Action', sortable: false }
      ],
      loading: true,
      items: [],
      totalItems: 0
    }
  },

  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    async filter() {
      this.loading = true
      const { data, total } = await this.handleGetTopQuestion()
      this.items = data
      this.totalItems = total
      this.loading = false
    }
  },
  async mounted() {
    this.loading = true
    const { data, total } = await this.handleGetTopQuestion()
    this.items = data
    this.totalItems = total
    this.loading = false
  },
  methods: {
    async handleGetTopQuestion() {
      try {
        const response = await ttbApi.getTopWrapUp({
          params: {
            page_id: this.selectedBot.pageid,
            limit: 5,
            offset: 0,
            app: this.filter.channel ? this.filter.channel : null,
            start_date: this.filter.startTime ? this.filter.startTime : null,
            end_date: this.filter.endTime ? this.filter.endTime : null
          }
        })
        return {
          data: response.data.data || [],
          total: response.data.total || 0
        }
      } catch (error) {
        console.error(error)
        return {
          data: [],
          total: 0
        }
      }
    },
    view(item) {
      this.$emit('view', { ...item })
    },
    handleExportButtonClick() {
      this.$emit('export', this.items)
    }
  }
}
</script>
<style lang="css">
/* @media screen and (min-width: 1560px) { */
#topQuestion th,
#topQuestion td {
  font-size: 32px !important;
}
#topQuestion td {
  font-weight: bold !important;
}
/* } */
</style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/TopQuestion.vue